import { useNavigation } from "@react-navigation/native"
import React from "react"
import { StyleSheet } from "react-native"
import { ScrollView } from "react-native"
import { useMediaQuery } from "react-responsive"

import Base, { Firebase } from "../../base"
import { ExpandableButton } from "../common"
// import DeliveryTimeslots from "./DeliveryTimeslots"
import OpeningHours from "./OpeningHours"
import { useSettingsColumnStyles } from "./styles"
import TimeSlotView from "./timeslots/TimeSlotView"
import VenueEnableView from "./VenueEnableView"

export default function VenueView(props) {
  const navigation = useNavigation()
  const isMobile = useMediaQuery(Base.constants.mobile)

  const containerStyles = useSettingsColumnStyles()

  function showMenu() {
    navigation.push("Menu")
    Firebase.logEvent("menu_stock")
  }

  return (
    <ScrollView
      style={containerStyles}
      contentContainerStyle={styles.scrollContainer}
      showsVerticalScrollIndicator={false}
    >
      {!isMobile && (
        <VenueEnableView
          service={props.service}
          onPress={props.toggleService}
        />
      )}
      <OpeningHours service={props.service} />
      <TimeSlotView service={props.service} setLoading={props.setLoading} />
      {/* <DeliveryTimeslots
        service={props.service}
        setLoading={props.setLoading}
      /> */}
      {isMobile && (
        <ExpandableButton
          title={"Menu Stock"}
          onPress={showMenu}
          static={true}
        />
      )}
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  scrollContainer: {
    paddingBottom: 50,
  },
})
